import axios from "axios";

import { clientBackOffice, clientCadastro, clientMapaMina, clientSimulador, clientTabelaPreco, clientFunilObras, clientRoteirizacao } from './request';
import errorHandling from "./errorHandling";
import { saveLocalStorage } from "~services/utils/SaveIndexBD";
import { db } from "~db/db";
import { get } from "lodash";


const requestCatchError = (err) => {
  const errorHandle = errorHandling(err);

  return {
    status: errorHandle.status,
    message: errorHandle.message,
    errors: err.response?.data?.errors || [],
    isSuccess: errorHandle.isSuccess
  }
};


const updateLastFetch = () => {
  saveLocalStorage("last-fetch-datetime", new Date());
};


const createApiMethod = (client) => (method) => (path, ...args) =>
  client[method](path, ...args)
    .then((res) => {
      if (res?.data?.isSuccess) updateLastFetch();
      return res.data;
    })
    .catch(requestCatchError);


const createApi = (client) => ({
  get: createApiMethod(client)("get"),
  post: createApiMethod(client)("post"),
  patch: createApiMethod(client)("patch"),
  put: createApiMethod(client)("put"),
  delete: createApiMethod(client)("delete"),
});

export const apiBackOffice = createApi(clientBackOffice);
export const apiCadastro = createApi(clientCadastro);
export const apiSimulacao = createApi(clientSimulador);
export const apiMapaMina = createApi(clientMapaMina);
export const apiTabelaPreco = createApi(clientTabelaPreco);
export const apiFunilObra = createApi(clientFunilObras);
export const apiRoteirizacao = createApi(clientRoteirizacao);

export const apiTest = axios.create({
  baseURL: 'https://jsonplaceholder.typicode.com/',
});

export const apiCorreios = axios.create({
  baseURL: 'https://viacep.com.br/ws/',
});